import {Customer} from "./Customer";
import {Address} from "./Address";
import {ShippingRate} from "./ShippingRate";
import {ShoppingCartStatus} from "./ShoppingCartStatus";
import {Note} from "./Note";
import {ShoppingBasketPrice} from "./ShoppingBasketPrice";
import {ShoppingBasketLineItem} from "./ShoppingBasketLineItem";
import {ShoppingBasketConfiguration} from "./ShoppingBasketConfiguration";
import {BlackoutZone} from "./BlackoutZone";

export class ShoppingBasket
{
	id = "";
	websiteId = "";
	customer = new Customer();
	selectedBillingAddress = new Address();
	selectedShippingAddress = new Address();
	status: ShoppingCartStatus;
	quotedShippingRates: Array<ShippingRate> = [];
	agreedToTerms: boolean;
	promoCode = "";
	taxExempt: boolean;
	displayOnlyBlackoutZones: Array<BlackoutZone> = [];
	lineItems: Array<ShoppingBasketLineItem> = [];
	priceAdjustments: Array<ShoppingBasketPrice> = [];
	poNumber = "";
	shippingAccountNumber = "";
	notes: Array<Note> = [];
	selectedShippingRate: ShippingRate;
	lineTotal: number;
	lineItemTotalQuantity: number;
	productDiscount: number;
	memberDiscount: number;
	customerOrderDiscount: number;
	promoDiscount: number;
	shippingHandling: number;
	estimatedTax: number;
	serviceCharge: number;
	subTotal: number;
	grandTotal: number;
	configuration: ShoppingBasketConfiguration;
// ReSharper disable InconsistentNaming
	isShippingTBD: boolean;
	isTaxTBD: boolean;
}


// WEBPACK FOOTER //
// ./src/models/ShoppingBasket.ts